import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    BarChart,
    Bar,
} from "recharts";

const WeeklyChart = ({ weeklyProduction }: any) => {


    // Ensure the data is correctly formatted
    const formattedData = weeklyProduction.map((item: any) => ({
        ...item,
        week_start_date: item.week_start_date.slice(0, 10), // Format date to YYYY-MM-DD
        invoice_total: Number(item.invoice_total),
        invoice_total_previous: Number(item.invoice_total_previous),
    }));

    // Separate data for current year and previous year
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;

    const currentYearData = formattedData.filter((item: any) => item.year === currentYear);
    const previousYearData = formattedData.filter((item: any) => item.year === previousYear);

    // Combine data for both years
    const combinedData = currentYearData.map((currentItem: any, index: number) => {
        const previousItem = previousYearData[index] || {};
        return {
            week_start_date: currentItem.week_start_date,
            current_invoice_total: currentItem.invoice_total,
            previous_invoice_total: previousItem.invoice_total || 0,
        };
    });

    return (
        <div className="bg-[#30343A] p-4 rounded col-span-2 h-full">
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={combinedData} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="week_start_date" tickFormatter={(tick) => tick.slice(5)} />
                    <YAxis tickFormatter={(tick) => `$${(tick / 100).toLocaleString()}`} />
                    <Tooltip formatter={(value: number) => `$${(value / 100).toLocaleString()}`} />
                    <Legend />
                    <Bar dataKey="current_invoice_total" fill="#49A8EA" name="Current Year" barSize={20} />
                    <Bar dataKey="previous_invoice_total" fill="#EA4950" name="Previous Year" barSize={20} />
                    <Line type="monotone" dataKey="current_invoice_total" stroke="#49A8EA" name="Current Year Trend" dot={false} />
                    <Line type="monotone" dataKey="previous_invoice_total" stroke="#EA4950" name="Previous Year Trend" dot={false} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default WeeklyChart;
